<template>
    <div class="modal fade modal-login" :id="propModalId" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i class="fas fa-times"></i>
                </button>
                <div class="modal-body">
                    <i class="fas fa-sign-in-alt"></i>
                    <p>{{ this.propMessage }}</p>
                    <div class="ink-button main-action fixed-width" v-on:click="OnClick_Login" aria-label="Login">Login
                    </div>
                    <div class="ink-button" v-on:click="OnClick_Register" aria-label="Criar registo">Criar registo</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        propReturnPage: {
            type: String,
            default: "/vehicles/contact-used"
        },
        propCreateRegistrationUrl: {
            type: String,
            default: "/vehicles/contact-used"
        },
        propMessage: {
            type: String,
            default: "Faça login ou crie um registo para enviar mensagem."
        },
        propModalId: {
            type: String,
            default: "loginModal"
        }
    },
    methods: {
        async OnClick_Login() {
            await this.$emit("OnLoginClick");
            window.location = this.propReturnPage;
        },
        async OnClick_Register() {
            this.$emit("OnRegisterClick");
            window.location = this.propCreateRegistrationUrl;
        },
    }
};
</script>